import { PRICING_V4_CATALOG_ID } from "./mocks";
import {
  v4CatalogChanged,
  v4UnitPrice,
  v4UnitPriceComparison
} from "./v4CatalogReference";
import { v4ReferenceState } from "./v4ReferenceState";
import { isV4ExplicitVector } from "./v4Selection";

export function v4CurrentPriceDelta(row, suggestion, requestStatus) {
  const reference = v4ReferenceState(suggestion, requestStatus);
  if (
    !reference.hasPrice ||
    !["maintain", "price_hypothesis"].includes(suggestion.stance) ||
    Number(suggestion.product_base_id) !== Number(row.product_base_id) ||
    Number(suggestion.catalog_id) !== PRICING_V4_CATALOG_ID
  )
    return { delta: null, reason: "Sem sugestão V4 comparável." };

  const comparison = v4UnitPriceComparison(suggestion);
  const observed = v4UnitPrice(comparison?.current_unit_price_brl);
  const current = isV4ExplicitVector(suggestion)
    ? observed
    : v4UnitPrice(row.preco_ameixa);
  const suggested = v4UnitPrice(comparison?.suggested_unit_price_brl);
  if (
    current === null ||
    current <= 0 ||
    observed === null ||
    observed <= 0 ||
    suggested === null ||
    suggested <= 0
  )
    return {
      delta: null,
      reason: "Sem preço equivalente da embalagem para comparar com o P. Atual."
    };
  if (v4CatalogChanged(suggestion, row))
    return {
      delta: null,
      reason: "O P. Atual mudou desde a análise V4. Aguarde uma nova rodada."
    };

  const delta = (suggested - current) / current;
  return Number.isFinite(delta)
    ? { delta, current, suggested, reference, comparison }
    : { delta: null, reason: "Sem sugestão V4 comparável." };
}
